import { render, staticRenderFns } from "./RestaurantEditForm.vue?vue&type=template&id=51187892&scoped=true&"
import script from "./RestaurantEditForm.vue?vue&type=script&lang=js&"
export * from "./RestaurantEditForm.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantEditForm.vue?vue&type=style&index=0&id=51187892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51187892",
  null
  
)

export default component.exports